"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveGridItem = ResponsiveGridItem;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const src_1 = require("../..");
/** Helper component for generating grid items with the ResponsiveGrid */
function ResponsiveGridItem(props) {
    const { colSpan, children } = props;
    const { gridItemProps } = (0, src_1.useResponsiveGridItem)({ colSpan });
    return (0, jsx_runtime_1.jsx)("div", { ...gridItemProps, children: children });
}
